var _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgYoutubeBlack = function SvgYoutubeBlack(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 49 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24.5,
    cy: 24,
    r: 24,
    fill: "#fff"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#youtube-black_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.088 19.191a2.506 2.506 0 0 0-1.763-1.763C30.76 17 24.5 17 24.5 17s-6.26 0-7.825.412c-.84.23-1.533.922-1.763 1.78-.412 1.564-.412 4.81-.412 4.81s0 3.262.412 4.81c.23.857.906 1.532 1.763 1.763 1.581.428 7.825.428 7.825.428s6.26 0 7.825-.412a2.506 2.506 0 0 0 1.763-1.762c.412-1.566.412-4.81.412-4.81s.016-3.263-.412-4.828Z",
    fill: "#363940"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m22.507 27 5.206-2.998-5.206-2.999V27Z",
    fill: "#fff"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "youtube-black_svg__a"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 14.5,
    y: 14,
    width: 20,
    height: 20,
    rx: 6,
    fill: "#fff"
  })))));
};
export default SvgYoutubeBlack;